import FolderIcon from '@mui/icons-material/FolderOutlined';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import useAlert from 'hooks/useAlert';
import React from 'react';
import FileActions from './FileActions';

const FolderItem = ({ folder, onSelectFolder, onDelete, onMove, onRename }) => {
  const alert = useAlert();

  const handleDelete = () => {
    return onDelete(folder);
  };

  const handleMove = () => {
    return onMove(folder);
  };

  const handleRename = async () => {
    await alert.prompt({
      inputValue: folder.folder_name,
      title: 'Enter folder name',
      onConfirm: (value) => onRename(folder, value),
    });
  };

  const onSelect = (e) => {
    e.preventDefault();
    onSelectFolder(folder);
  };

  return (
    <ListItem button dense onClick={onSelect}>
      <ListItemIcon>
        <FolderIcon />
      </ListItemIcon>
      <ListItemText primary={folder.folder_name} />
      <ListItemSecondaryAction>
        <FileActions
          onDelete={handleDelete}
          onMove={handleMove}
          onRename={handleRename}
        />
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default FolderItem;
